const getSupplierFax3 = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return business && business['Company Contact'] && business['Company Contact'].Fax
    ? business['Company Contact'].Fax.replace('+1 ', '').replace(/[\s()-]/g, '').slice(6, 10) : null;
};

export default getSupplierFax3;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierFax3.js